import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
dayjs.locale('th');

export class ProgramList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programs: [],
            loading: true,
            search: '',
            countryFilter: '0',
            countryList: []
        };
    }

    componentDidMount() {
        this.loadPrograms();
        this.loadCountries();
    }

    loadPrograms() {
        this.setState({ loading: true });
        fetch('api/ProgramList?country_id=0&province_id=0&code=&name=')
            .then(r => r.ok ? r.json() : [])
            .then(json => this.setState({ programs: json, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    loadCountries() {
        fetch('api/GetCountrylist')
            .then(r => r.ok ? r.json() : [])
            .then(json => this.setState({ countryList: json }))
            .catch(() => {});
    }

    deleteProgram(id, name) {
        if (!window.confirm('ต้องการลบ "' + name + '" หรือไม่?')) return;
        fetch('api/ProgramManage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ data: { proG_ID: id, isdelete: 1 } })
        })
            .then(r => { if (r.ok) this.loadPrograms(); })
            .catch(() => {});
    }

    render() {
        const { programs, loading, search } = this.state;

        var filtered = programs;
        if (search) {
            var s = search.toLowerCase();
            filtered = programs.filter(p =>
                (p.proG_CODE && p.proG_CODE.toLowerCase().includes(s)) ||
                (p.proG_NAME && p.proG_NAME.toLowerCase().includes(s)) ||
                (p.proG_CAPTION && p.proG_CAPTION.toLowerCase().includes(s))
            );
        }

        return (
            <div style={{ padding: 20 }}>
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {filtered.length} รายการ</p>
                    <Link to="/console/programcreate" className="btn btn-danger">
                        <i className="fas fa-plus"></i> สร้างโปรแกรมใหม่
                    </Link>
                </div>

                {/* Search */}
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="input-group">
                            <span className="input-group-text"><i className="fas fa-search"></i></span>
                            <input type="text" className="form-control" placeholder="ค้นหา รหัส, ชื่อ, สถานที่..."
                                value={search} onChange={e => this.setState({ search: e.target.value })} />
                            {search && <button className="btn btn-outline-secondary" onClick={() => this.setState({ search: '' })}><i className="fas fa-times"></i></button>}
                        </div>
                    </div>
                </div>

                {/* Table */}
                {loading ? (
                    <div className="text-center py-5"><i className="fas fa-spinner fa-spin fa-2x"></i><br />กำลังโหลด...</div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#999' }}>
                        <i className="fas fa-inbox fa-3x mb-3" style={{ display: 'block' }}></i>
                        {search ? 'ไม่พบรายการที่ค้นหา' : 'ยังไม่มีโปรแกรมทัวร์'}
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover" style={{ fontSize: 14 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 60 }}>#</th>
                                    <th style={{ width: 80 }}>ภาพ</th>
                                    <th style={{ width: 100 }}>รหัส</th>
                                    <th>ชื่อโปรแกรม</th>
                                    <th style={{ width: 80, textAlign: 'center' }}>วัน/คืน</th>
                                    <th style={{ width: 120 }}>สายการบิน</th>
                                    <th style={{ width: 120 }}>เดินทาง</th>
                                    <th style={{ width: 100, textAlign: 'right' }}>ราคาเริ่ม</th>
                                    <th style={{ width: 100, textAlign: 'center' }}>จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((p, i) => (
                                    <tr key={p.proG_ID}>
                                        <td style={{ color: '#999' }}>{i + 1}</td>
                                        <td>
                                            <img src={p.proG_COVER_IMG || '/images/importClick.png'}
                                                alt="" style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }} />
                                        </td>
                                        <td><span className="badge" style={{ background: '#dc3545', color: '#fff' }}>{p.proG_CODE}</span></td>
                                        <td>
                                            <div style={{ fontWeight: 600 }}>{p.proG_NAME}</div>
                                            {p.proG_CAPTION && <div style={{ color: '#888', fontSize: 12 }}>{p.proG_CAPTION}</div>}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>{p.proG_DAYS}D{p.proG_NIGHT}N</td>
                                        <td>
                                            {p.airL_LOGO && <img src={p.airL_LOGO} alt="" style={{ height: 18, marginRight: 4 }} />}
                                            <span style={{ fontSize: 12 }}>{p.airL_NAME}</span>
                                        </td>
                                        <td style={{ fontSize: 12 }}>
                                            {p.sooN_START && p.sooN_START !== '' ?
                                                dayjs(p.sooN_START).format('D MMM YY') : '-'}
                                        </td>
                                        <td style={{ textAlign: 'right', fontWeight: 600, color: '#dc3545' }}>
                                            {p.proG_START_PRICE ? p.proG_START_PRICE + '.-' : '-'}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <Link to={'/console/programmanagement'}
                                                className="btn btn-outline-primary btn-sm me-1" style={{ marginRight: 4 }}
                                                title="แก้ไข">
                                                <i className="fas fa-edit"></i>
                                            </Link>
                                            <button className="btn btn-outline-danger btn-sm"
                                                onClick={() => this.deleteProgram(p.proG_ID, p.proG_NAME)}
                                                title="ลบ">
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}
